import simpleParallax from 'simple-parallax-js';

jQuery( document ).ready(function(jQuery) {
    const initParallax = (ParallaxBlocks) => {
        var instance = new simpleParallax(ParallaxBlocks, {
            overflow: true,
            scale: 1.5,
            orientation: "up",
            delay: 0,
            maxTransition: "100%",
        });
        return instance;
    }
    // Detect whether the user is running IE11
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    /**
     * Parallax images in feature blocks
     */
    if(!isIE11 && jQuery('.parallax-img').length) {
        var ParallaxBlocks = document.querySelectorAll('.parallax-img');

        var ParallaxImages = initParallax(ParallaxBlocks);
        jQuery(window).resize(function () {
            // Check window size, this number should probably match the md breakpoint variable
            if($(window).width() < 992) {
                ParallaxImages.destroy();
            } else {
                ParallaxImages = initParallax(ParallaxBlocks);
            }
        });
    }
});